<template>
    <div>
        <AppDatePicker :value="fromDate"
                       placeholder="From date"
                       @input="$emit('on-from-input', $event)"
                       allow-empty="true"
                       :disabled="disabled"
                       class="w-auto mb-sm-0 mb-2 pr-sm-2"/>
        <AppDatePicker :value="toDate"
                       placeholder="To date"
                       @input="$emit('on-to-input', $event)"
                       allow-empty="true"
                       :disabled="disabled"
                       class="w-auto mb-sm-0 mb-2"/>
    </div>
</template>

<script>
import AppDatePicker from './AppDatePicker';

export default {
  props: ['fromDate', 'toDate', 'disabled'],
  components: {
    AppDatePicker,
  },
};
</script>
